module.exports = __webpack_public_path__ + "static/img/update@2x (1).ce2a09bb.png";